import React, { ReactNode } from "react";
import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { PillNavigation } from "@/components/PillNavigation";
import RoundedPeriod from "../common/RoundedPeriod";

export const LearningCenterLayout:React.FC<{
  isHomePage?: boolean,
  showIntercom?: boolean,
  children?: ReactNode,
}> = ({ isHomePage = false, 
  children = null, 
  showIntercom=false
}) => { 
  return (
    <div className="px-0 py-0 lg:p-0 flex flex-col justify-center items-center bg-ii-black" data-is-root-path={isHomePage}>
      <Header isHomepage={isHomePage} showIntercom={showIntercom} />
      <div
        className="w-full lg:max-w-learning-center-navigation max-w-learning-center-navigation-mobile text-center
          flex-col items-center h-learning-center-hero-mobile lg:h-learning-center-hero pt-6 lg:pt-134.5px relative"
      >
        <h1 className="text-5xl font-bold text-ii-white">Learning Center<RoundedPeriod /> </h1>
        <div
          className="w-full lg:max-w-learning-center-navigation max-w-learning-center-navigation-mobile flex
            justify-center items-center absolute bottom-0 lg:top-295.5px top-192px"
        >
          <PillNavigation />
        </div>
      </div>
      <main className="container mx-auto max-w-full px-0 bg-ii-white">{children}</main>
      <Footer />
      <div className="osano-cm-widget" /> {/* required to hide osano cookie icon */}
    </div>
  );
};

LearningCenterLayout.defaultProps = {
  isHomePage: false,
  children: null,
  showIntercom: false
};
